import { render } from "./EnbCompNaves.vue?vue&type=template&id=72ae6592&scoped=true"
import script from "./EnbCompNaves.vue?vue&type=script&lang=js"
export * from "./EnbCompNaves.vue?vue&type=script&lang=js"

import "./EnbCompNaves.vue?vue&type=style&index=0&id=72ae6592&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72ae6592"]])

export default __exports__